import { OTA_POS } from "./ota_pos.model";
import { OTA_VehModifyRQCore } from "./ota_vehmodifyrqcore.model";
import { OTA_VehModifyRQInfo } from "./ota_vehmodifyrqinfo.model";
import { OTA_UniqueID } from "./ota_uniqueid.model";

export class OTA_VehModifyRQ {
    public pos = new OTA_POS();
    public uniqueID = new OTA_UniqueID();
    public vehModifyRQCore = new OTA_VehModifyRQCore();
    public vehModifyRQInfo = new OTA_VehModifyRQInfo();
}